import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-summary-orders',
  templateUrl: './summary-orders.component.html',
  styleUrls: ['./summary-orders.component.css']
})
export class SummaryOrdersComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
